import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import DOMPurify from 'dompurify';
import RichTextEditor, { stripImageHostFromContent, restoreImageHostInContent, resolveImageUrl } from "../../common/HtmlEditor";
import { withStyles } from "@material-ui/core";
import { Box, Typography, Button, TextField, Toolbar, IconButton, MenuItem, CircularProgress, Chip, Divider, Modal, Select, Switch } from "@mui/material";
import Grid from "@material-ui/core/Grid/Grid";
import ArrowBack from '@mui/icons-material/ArrowBack';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from "@mui/icons-material/Close";
import CalendarIcon from "@mui/icons-material/CalendarToday";
import UserIcon from "@mui/icons-material/Person";
import VisibilityIcon from "@mui/icons-material/Visibility";
import NewsletterIcon from "@mui/icons-material/Email";
import "./styles.css";
import styles from "./styles";
import { messageShow } from "../../common/api/actions";
import { createOrUpdateCms, createOrUpdateCategory } from '../api/actions/mutation';
import { getCms, getCmsById, getCategories, getBaseUrls } from "../api/actions/query";
import { uploadThumbnail } from '../api/actions/aiActions';
import { checkPermission } from "../../common/Sidebar/checkPermission";
import { createEvent, sendNewsletterCampaign } from '../../marketing/api/action/mutation';
import routes from '../api/routes';

class CreateOrUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: "",
      title: "",
      content: "",
      selectedTags: [],
      tagInput: "",
      thumbnail: "",
      slug: "",
      isUploading: false,
      permissions: {
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      },
      allTags: [],
      isPreviewOpen: false,
      status: "draft",
      category: "blog",
      type: "blog",
      subtitle: "",
      mediaType: "image",
      mediaUrl: "default.jpg",
      videoUrl: "",
      thumbnailUrl: "",
      authorName: "",
      sort: 0,
      rating: 5,
      allCategories: [],
      newCategoryInput: "",
      isAddingCategory: false,
      eventStartDate: "",
      eventEndDate: "",
      eventLocation: "",
      unsubscribeText: "If you no longer wish to receive these emails, you can",
      includeUnsubscribeLink: true,
      createdAt: "", // For datePublished in SEO
      // SEO Fields
      seo: {
        metaTitle: "",
        metaDescription: "",
        metaKeywords: [],
        route: "",
        ogImage: "",
        ogTitle: "",
        ogDescription: "",
        targetBaseUrl: ""
      },
      targetBaseUrl: "",
      availableBaseUrls: [],
      seoKeywordInput: "",
      isNewsletterPublishModalOpen: false
    };
    this.editorRef = React.createRef();
  }

  componentDidMount() {
    const cmsId = this.props.cmsId || (this.props.match && this.props.match.params && this.props.match.params.cmsId);

    // Parse category from query param if it exists (e.g. ?cat=news)
    const urlParams = new URLSearchParams(this.props.location.search);
    const catParam = urlParams.get('cat');
    if (catParam) {
      this.setState({ category: catParam });
    }

    if (cmsId) {
      this.getCms(cmsId);
    }
    this.fetchAllTags();
    this.fetchAllCategories();
    void this.fetchBaseUrls();
    this.verifyPermissions();
  }
  componentDidUpdate(prevProps, prevState) {
    // Reload data when cmsId changes (e.g., when editing a different item)
    const currentCmsId = this.props.cmsId || (this.props.match && this.props.match.params && this.props.match.params.cmsId);
    const prevCmsId = prevProps.cmsId || (prevProps.match && prevProps.match.params && prevProps.match.params.cmsId);

    if (currentCmsId && currentCmsId !== prevCmsId) {
            this.getCms(currentCmsId);
    }

    if (this.state.category !== prevState.category || this.state.allCategories !== prevState.allCategories) {
      if (this.state.category && /^[0-9a-fA-F]{24}$/.test(this.state.category) && this.state.allCategories.length > 0) {
        const found = this.state.allCategories.find(c => c._id === this.state.category || c.slug === this.state.category);
        if (found) {
          const resolvedSlug = (found.slug && !/^[0-9a-fA-F]{24}$/.test(found.slug)) ? found.slug : (found.name || 'blog').toLowerCase().trim().replace(/\s+/g, '-');
          this.setState({ category: resolvedSlug });
        } else {
          this.setState({ category: 'blog' });
        }
      }
    }
  }



  fetchAllTags = async () => {
    try {
      const response = await this.props.getCms();
      if (response.data.success) {
        const allItems = response.data.data || [];
        const tagSet = new Set([]);

        allItems.forEach(item => {
          if (item.tag) {
            item.tag.split(',').forEach(t => {
              const formatted = t.trim().replace(/_/g, " ").toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
              if (formatted) tagSet.add(formatted);
            });
          }
        });
        this.setState({ allTags: Array.from(tagSet).sort() });
      }
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  }

  fetchAllCategories = async () => {
    try {
      const { getCategories } = this.props;
      const response = await getCategories();
      if (response.data.success) {
        this.setState({ allCategories: response.data.data || [] });
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  }

  fetchBaseUrls = async () => {
    try {
      const { getBaseUrls } = this.props;
      if (getBaseUrls) {
        const response = await getBaseUrls();
        if (response?.data?.success) {
          const list = response.data.data || [];
          this.setState({ availableBaseUrls: list });
        }
      }
    } catch (error) {
      console.error("Error fetching base URLs:", error);
    }
  }

  handleAddCategory = async () => {
    const { newCategoryInput, allCategories } = this.state;
    const { createOrUpdateCategory } = this.props;
    if (newCategoryInput.trim()) {
      const slug = newCategoryInput.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      try {
        const response = await createOrUpdateCategory({
          name: newCategoryInput.trim(),
          slug,
          sort: allCategories.length
        });
        if (response.data.success) {
          this.setState({
            category: slug,
            newCategoryInput: "",
            isAddingCategory: false
          });
          this.fetchAllCategories();
        }
      } catch (error) {
        console.error("Error adding category:", error);
      }
    }
  }

  verifyPermissions = async () => {
    const modulePermissions = await checkPermission("marketing", "resource");
    this.setState({
      permissions: {
        canView: modulePermissions.canView,
        canCreate: modulePermissions.canCreate,
        canEdit: modulePermissions.canEdit,
        canDelete: modulePermissions.canDelete,
      }
    });
  }

  getCms = async (cmsId) => {
    const { messageShow, getCmsById } = this.props;

    try {
      const { data } = await getCmsById({ cmsId });
      if (data && data.success && data.data) {
        const rawTag = data.data.tag || "";
        const parsedTags = rawTag.split(',').map(t => t.trim().replace(/_/g, " ").toLowerCase().replace(/\b\w/g, c => c.toUpperCase())).filter(Boolean);
        this.setState({
          _id: data.data._id,
          title: data.data.title || "",
          content: restoreImageHostInContent(data.data.content || ""),
          thumbnail: data.data.thumbnail || "",
          selectedTags: parsedTags,
          slug: data.data.slug || "",
          status: data.data.status || "draft",
          category: (data.data.category || "blog").toLowerCase(),
          type: data.data.type || data.data.category || "blog",
          subtitle: data.data.subtitle || "",
          mediaType: data.data.mediaType || "image",
          mediaUrl: data.data.mediaUrl || "default.jpg",
          videoUrl: data.data.videoUrl || "",
          thumbnailUrl: data.data.thumbnailUrl || "",
          authorName: data.data.seo?.authorName || data.data.authorName || "",
          sort: data.data.sort || 0,
          rating: data.data.rating || 5,
          eventStartDate: data.data.eventStartDate ? new Date(data.data.eventStartDate).toISOString().split('T')[0] : "",
          eventEndDate: data.data.eventEndDate ? new Date(data.data.eventEndDate).toISOString().split('T')[0] : "",
          eventLocation: data.data.eventLocation || "",
          unsubscribeText: (data.data.unsubscribeText || "If you no longer wish to receive these emails, you can unsubscribe here.").replace(/\s*unsubscribe here\.?$/i, ''),
          includeUnsubscribeLink: data.data.includeUnsubscribeLink !== false,
          targetBaseUrl: data.data.targetBaseUrl || data.data.seo?.targetBaseUrl || "",
          createdAt: data.data.createdAt || new Date().toISOString(), // Store createdAt for datePublished
          // Load SEO fields - auto-populate from blog data if empty or mismatched
          seo: {
            // If SEO title is empty or doesn't match current title, use current title
            metaTitle: (data.data.seo?.metaTitle && data.data.seo.metaTitle.length > 3)
              ? data.data.seo.metaTitle
              : data.data.title || "",
            metaDescription: data.data.seo?.metaDescription || data.data.subtitle || "",
            metaKeywords: Array.isArray(data.data.seo?.metaKeywords) ? data.data.seo.metaKeywords : [],
            route: data.data.seo?.route || `/${(data.data.category || "blog").toLowerCase()}/${data.data.slug || ""}`,
            targetBaseUrl: data.data.targetBaseUrl || data.data.seo?.targetBaseUrl || "",
            ogImage: data.data.seo?.ogImage || data.data.thumbnail || "",
            // If OG title is empty or doesn't match, use current title
            ogTitle: (data.data.seo?.ogTitle && data.data.seo.ogTitle.length > 3)
              ? data.data.seo.ogTitle
              : data.data.title || "",
            ogDescription: data.data.seo?.ogDescription || data.data.subtitle || ""
          }
        }, () => {
                              /*console.log('[Admin] 🔑 SEO Keywords check:', {
            metaKeywords: this.state.seo.metaKeywords,
            isArray: Array.isArray(this.state.seo.metaKeywords),
            length: this.state.seo.metaKeywords?.length,
            rawKeywords: data.data.seo?.metaKeywords
          });*/
        });
      } else {
        messageShow(data?.message || "Template not found.");
      }
    } catch (error) {
      console.error("Error loading CMS template:", error);
      messageShow("There was some error loading the template. Please try again.");
    }
  };

  handleTitleChange = (event) => {
    const title = event.target.value;
    const newState = { title };
    newState.slug = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

    // Auto-generate SEO fields if empty
    if (!this.state.seo.metaTitle) {
      newState.seo = {
        ...this.state.seo,
        metaTitle: title,
        ogTitle: title,
        route: `/${this.state.category}/${newState.slug}`
      };
    }

    this.setState(newState);
  };

  handleContentChange = (value) => {
    this.setState({ content: value });
  };

  handleTagChange = (event) => {
    const val = event.target.value;
    if (val && !this.state.selectedTags.includes(val)) {
      if (this.state.selectedTags.length >= 3) {
        this.props.messageShow("Maximum 3 tags allowed per blog!");
        return;
      }
      this.setState(prev => ({ selectedTags: [...prev.selectedTags, val] }));
    }
  };

  handleTagInputKeyDown = (e) => {
    const { tagInput, selectedTags } = this.state;
    if ((e.key === 'Enter' || e.key === ',') && tagInput.trim()) {
      e.preventDefault();
      if (selectedTags.length >= 3) {
        this.props.messageShow("Maximum 3 tags allowed per blog!");
        return;
      }
      const t = tagInput.replace(',', '').trim();
      if (t && !selectedTags.includes(t)) this.setState({ selectedTags: [...selectedTags, t], tagInput: '' });
      else this.setState({ tagInput: '' });
    } else if (e.key === 'Backspace' && !tagInput && selectedTags.length) {
      this.setState({ selectedTags: selectedTags.slice(0, -1) });
    }
  };

  removeTag = (index) => {
    this.setState(prev => ({ selectedTags: prev.selectedTags.filter((_, i) => i !== index) }));
  };

  handleThumbnailUrlChange = (event) => {
    this.setState({ thumbnail: event.target.value });
  };

  handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const { uploadThumbnail, messageShow } = this.props;
    this.setState({ isUploading: true });
    try {
      const response = await uploadThumbnail(file);
      const imageUrl = response.data.file || response.data.url;
      if (imageUrl) {
        this.setState({ thumbnail: imageUrl });
        messageShow("Thumbnail uploaded successfully!");
      } else {
        messageShow("Upload succeeded but no URL returned.");
      }
    } catch (error) {
      console.error("Thumbnail upload failed:", error);
      messageShow("Thumbnail upload failed.");
    } finally {
      this.setState({ isUploading: false });
    }
  };

  handleSave = async () => {
    const { title, content, selectedTags, status, category } = this.state;
    const { messageShow } = this.props;

    if (!title.trim()) {
      messageShow("Title cannot be empty!");
      return;
    }

    if (!selectedTags.length) {
      messageShow("Please add at least one tag!");
      return;
    }

    if (selectedTags.length > 3) {
      messageShow("Maximum 3 tags allowed per blog!");
      return;
    }

    if (!content.trim()) {
      messageShow("Content cannot be empty!");
      return;
    }

    if (category?.toLowerCase() === 'newsletter' && status === 'published') {
      this.setState({ isNewsletterPublishModalOpen: true });
      return;
    }

    this.saveContent(false);
  };

  saveContent = async (sendToSubscribers = false) => {
    const { _id, title, content, selectedTags, thumbnail, slug, status, category, seo, subtitle, eventStartDate, eventEndDate } = this.state;
    const { messageShow, createOrUpdateCms, history } = this.props;

    this.setState({ isNewsletterPublishModalOpen: false });

    const finalSlug = (slug || title).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || (_id ? _id : 'untitled');
    const currentUser = (() => { try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch (e) { return {}; } })();
    const userId = currentUser._id || '';

    try {
      const sanitizedContent = DOMPurify.sanitize(stripImageHostFromContent(content), {
        ADD_TAGS: ["iframe", "figure", "oembed", "video", "source", "script"],
        ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "src", "data-oembed-url", "url", "width", "height", "style", "title", "loading", "autoplay", "muted", "controls", "playsinline", "srcdoc", "itemprop", "itemtype", "content", "target", "rel"]
      });
      const formattedTag = selectedTags.map(t => t.replace(/\s+/g, '_').toUpperCase()).join(',');

      // Extract first 160 chars from content for description if subtitle is empty
      const extractDescription = () => {
        if (subtitle) return subtitle;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sanitizedContent;
        const textContent = tempDiv.textContent || tempDiv.innerText || '';
        return textContent.substring(0, 160).trim();
      };

      let finalContent = sanitizedContent;
      const currentAuthor = this.state.authorName.trim();
      const targetBaseUrl = typeof this.state.targetBaseUrl === 'string' 
        ? this.state.targetBaseUrl 
        : (this.state.seo?.targetBaseUrl || "");

      // Get category route from allCategories
      const categoryData = this.state.allCategories.find(c => c.slug === category);
      const categoryRoute = categoryData?.route || `/${category}`;
      
      // Auto-fill SEO data from blog data
      const seoData = {
        metaTitle: (seo.metaTitle && seo.metaTitle.length > 3) ? seo.metaTitle : title,
        metaDescription: seo.metaDescription || extractDescription(),
        authorName: currentAuthor,
        datePublished: _id ? this.state.createdAt : new Date().toISOString(),
        metaKeywords: Array.isArray(seo.metaKeywords) ? seo.metaKeywords : [],
        ogImage: seo.ogImage || thumbnail || "",
        ogTitle: (seo.ogTitle && seo.ogTitle.length > 3) ? seo.ogTitle : ((seo.metaTitle && seo.metaTitle.length > 3) ? seo.metaTitle : title),
        ogDescription: seo.ogDescription || seo.metaDescription || extractDescription(),
        route: `${categoryRoute}/${finalSlug}`,
        targetBaseUrl: targetBaseUrl,
        ...(category?.toLowerCase() === 'event' && eventStartDate && {
          seoStartDate: new Date(eventStartDate).toISOString()
        }),
        ...(category?.toLowerCase() === 'event' && eventEndDate && {
          seoEndDate: new Date(eventEndDate).toISOString()
        })
      };

      const cmsData = {
        _id,
        title,
        content: finalContent,
        tag: formattedTag,
        thumbnail,
        slug: finalSlug,
        authorId: userId,
        isAiGenerated: false,
        status: status,
        category: this.state.category,
        targetBaseUrl: targetBaseUrl,
        subtitle: this.state.subtitle,
        mediaType: this.state.mediaType,
        mediaUrl: this.state.mediaUrl,
        videoUrl: this.state.videoUrl,
        thumbnailUrl: this.state.thumbnailUrl,
        sort: this.state.sort,
        rating: this.state.rating,
        unsubscribeText: this.state.unsubscribeText.trim() + " unsubscribe here.",
        includeUnsubscribeLink: this.state.includeUnsubscribeLink,
        type: this.state.type || this.state.category,
        isSent: (this.state.category?.toLowerCase() === 'newsletter' && status === 'published' && sendToSubscribers) ? true : (this.state.isSent || false),
        seo: seoData,
        ...(this.state.eventStartDate && { eventStartDate: new Date(this.state.eventStartDate).toISOString() }),
        ...(this.state.eventEndDate && { eventEndDate: new Date(this.state.eventEndDate).toISOString() }),
        ...(this.state.eventLocation && { eventLocation: this.state.eventLocation }),
        ...(_id ? { updatedById: userId } : { createdById: userId }),
      };

      const response = await createOrUpdateCms(cmsData);
      if (response && response.data && response.data.success) {
        const currentCategory = (category || "").toLowerCase();
        
        if (status === 'published' && currentCategory === 'newsletter') {
          if (sendToSubscribers) {
            const newsletterId = response.data.data._id;
            try {
              const campResult = await sendNewsletterCampaign(newsletterId);
              if (campResult && campResult.error) throw new Error(campResult.error);
              messageShow("Newsletter published and email campaign sent to subscribers!");
            } catch (campErr) {
              console.error("sendNewsletterCampaign failed:", campErr);
              messageShow("Newsletter published, but email campaign failed to start.");
            }
          } else {
            messageShow("Newsletter published (email campaign was not sent).");
          }
        } else if (status === 'published' && currentCategory === 'social') {
          messageShow("Social post published!");
        } else {
          messageShow(response.data.message || "Content saved successfully!");
        }

        if (this.props.onClose) {
          this.props.onClose();
        } else {
          const navHistory = history || this.props.history;
          if (navHistory && navHistory.push) {
            navHistory.push(routes.cmsList.path);
          } else {
            window.location.href = '/cms';
          }
        }
      } else {
        const errorMsg = response?.data?.message || "Failed to save content. Please try again.";
        console.error("Save failed response from server:", errorMsg);
        messageShow(errorMsg);
      }
    } catch (error) {
      console.error(error);
      messageShow("An error occurred while saving content. Check console for details.");
    }
  };

  handleClear = () => {
    this.setState({ title: "", content: "", selectedTags: [], tagInput: "", thumbnail: "", slug: "", metaDescription: "", keywords: "", category: "blog", targetBaseUrl: "", subtitle: "", mediaType: "image", mediaUrl: "default.jpg", videoUrl: "", thumbnailUrl: "", authorName: "", sort: 0, rating: 5, eventStartDate: "", eventEndDate: "", eventLocation: "" });
  };

  render() {
    const { title, content, selectedTags, tagInput, thumbnail, slug, isUploading, permissions, allTags, isPreviewOpen, status, category, subtitle, authorName, sort } = this.state;
    const { classes } = this.props;
    const cmsId = this.props.cmsId || (this.props.match && this.props.match.params && this.props.match.params.cmsId);
    const isModal = this.props.isModal;
    const canSave = cmsId ? permissions.canEdit : permissions.canCreate;

    return (
      <Box className={isModal ? "" : classes.wrapper} sx={{ width: '100%' }}>
        {!isModal && (
          <Toolbar className={classes.toolbar}>
            <IconButton
              className={classes.menuButton}
              color="inherit"
              onClick={() => this.props.history.push(routes.cmsList.path)}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h6" color="inherit" className={classes.grow}>
              {cmsId ? "Edit" : "Create"} Template
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<VisibilityIcon />}
              onClick={() => this.setState({ isPreviewOpen: true })}
              sx={{
                textTransform: 'none',
                borderRadius: '8px',
                fontWeight: 600,
                borderColor: '#E9ECEF',
                color: '#525F7F',
                ml: 2,
                '&:hover': { bgcolor: '#F8F9FE', borderColor: '#0d3559', color: '#0d3559' }
              }}
            >
              Preview
            </Button>
          </Toolbar>
        )}

        <Box sx={{ mt: isModal ? 0 : 4, pl: 3 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#525F7F' }}>TEMPLATE TITLE</Typography>
                <TextField
                  placeholder="Enter a descriptive title..."
                  value={title}
                  onChange={this.handleTitleChange}
                  fullWidth
                  variant="outlined"
                  size="small"
                  sx={{
                    bgcolor: '#FAFAFA',
                    '& .MuiOutlinedInput-root': { borderRadius: '8px' }
                  }}
                />
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#525F7F' }}>CONTENT EDITOR</Typography>
                <RichTextEditor
                  value={content}
                  onChange={this.handleContentChange}
                  editorRef={this.editorRef}
                  uploadType="cms"
                />
              </Box>

              <Box sx={{ mt: 5 }}>
                <Divider sx={{ mb: 3 }} />

                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#525F7F' }}>CUSTOM SLUG</Typography>
                      <TextField
                        placeholder="e.g. construction-trends-2025"
                        value={slug}
                        onChange={(e) => this.setState({ slug: e.target.value })}
                        fullWidth
                        variant="outlined"
                        size="small"
                        sx={{ bgcolor: '#FAFAFA', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ p: 3, bgcolor: '#FAFAFA', borderRadius: '12px', border: '1px solid #E9ECEF' }}>
                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#32325D' }}>CONFIGURATIONS</Typography>

                {category?.toLowerCase() !== 'newsletter' && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#8898AA', fontWeight: 700 }}>SUBTITLE</Typography>
                    <TextField
                      placeholder="Enter subtitle..."
                      value={subtitle}
                      onChange={(e) => this.setState({ subtitle: e.target.value })}
                      fullWidth
                      variant="outlined"
                      size="small"
                      sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                    />
                  </Box>
                )}

                <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#8898AA', fontWeight: 700 }}>PUBLISH STATUS</Typography>
                    <Select
                        value={status}
                        onChange={(e) => this.setState({ status: e.target.value })}
                        fullWidth
                        size="small"
                        variant="outlined"
                        sx={{
                            bgcolor: 'white',
                            '& .MuiOutlinedInput-root': { borderRadius: '8px' },
                            '& .MuiSelect-select': { py: 1.5, fontWeight: 600, color: status === 'published' ? '#2e7d32' : '#ed6c02' }
                        }}
                    >
                        <MenuItem value="draft">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#ed6c02' }} />
                                Draft
                            </Box>
                        </MenuItem>
                        <MenuItem value="published">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#2e7d32' }} />
                                Published
                            </Box>
                        </MenuItem>
                    </Select>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography variant="caption" sx={{ color: '#8898AA', fontWeight: 700 }}>CATEGORY</Typography>
                        <Button 
                            size="small" 
                            onClick={() => this.setState({ isAddingCategory: !this.state.isAddingCategory })}
                            sx={{ textTransform: 'none', fontSize: '10px', p: 0 }}
                        >
                            {this.state.isAddingCategory ? "Cancel" : "+ New Category"}
                        </Button>
                    </Box>

                    {this.state.isAddingCategory ? (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <TextField
                                placeholder="Enter category name..."
                                value={this.state.newCategoryInput}
                                onChange={(e) => this.setState({ newCategoryInput: e.target.value })}
                                fullWidth
                                size="small"
                                sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                            />
                            <Button
                                variant="contained"
                                size="small"
                                onClick={this.handleAddCategory}
                                disabled={!permissions.canCreate}
                                sx={{ bgcolor: permissions.canCreate ? '#0d3559' : '#8898AA', color: 'white', borderRadius: '8px', '&:hover': { bgcolor: permissions.canCreate ? '#092a46' : '#8898AA', color: 'white' } }}
                            >
                                Add
                            </Button>
                        </Box>
                    ) : (
                        <Select
                            value={category || ""}
                            onChange={(e) => {
                                const val = e.target.value;
                                this.setState({
                                    category: val,
                                    type: (val === 'newsletter') ? 'newsletter' : this.state.type
                                });
                            }}
                            fullWidth
                            size="small"
                            variant="outlined"
                            sx={{
                                bgcolor: 'white',
                                '& .MuiOutlinedInput-root': { borderRadius: '8px' },
                                '& .MuiSelect-select': { py: 1.5, fontWeight: 600, color: '#32325D', textTransform: 'capitalize' }
                            }}
                        >
                            {!this.state.allCategories.some(cat => cat.slug === 'blog') ? (
                                <MenuItem value="blog">Blog</MenuItem>
                            ) : null}
                            {!this.state.allCategories.some(cat => cat.slug === 'newsletter') ? (
                                <MenuItem value="newsletter">Newsletter</MenuItem>
                            ) : null}

                            {this.state.allCategories
                              .filter(cat => !/^[0-9a-fA-F]{24}$/.test(cat.name))
                              .map(cat => {
                                const val = (cat.slug && !/^[0-9a-fA-F]{24}$/.test(cat.slug)) ? cat.slug : cat.name.toLowerCase().trim().replace(/\s+/g, '-');
                                return (
                                  <MenuItem key={cat._id || val} value={val} sx={{ textTransform: 'capitalize' }}>
                                    {cat.name}
                                  </MenuItem>
                                );
                              })
                            }
                        </Select>
                    )}
                </Box>

                {/* Author Name */}
                <Box sx={{ mb: 3 }}>
                  <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#8898AA', fontWeight: 700 }}>AUTHOR NAME</Typography>
                  <TextField
                    placeholder="Enter author name..."
                    value={authorName}
                    onChange={(e) => this.setState({ authorName: e.target.value })}
                    fullWidth
                    variant="outlined"
                    size="small"
                    sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                  />
                </Box>

                {/* Base URL - only show if additional subdomain exists */}
                {this.state.availableBaseUrls?.some(item => !item.isPrimary && item.url) && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#8898AA', fontWeight: 700 }}>
                      BASE URL
                    </Typography>
                    <Select
                      value={this.state.targetBaseUrl || ""}
                      onChange={(e) => {
                        const val = e.target.value;
                        this.setState(prevState => ({
                          targetBaseUrl: val,
                          seo: {
                            ...prevState.seo,
                            targetBaseUrl: val
                          }
                        }));
                      }}
                      fullWidth
                      displayEmpty
                      size="small"
                      variant="outlined"
                      renderValue={(selected) => {
                        const cleanSel = String(selected || "").trim().replace(/\/$/, "");
                        const matched = this.state.availableBaseUrls.find(i => 
                          (i.isPrimary && !cleanSel) || 
                          (i.url?.replace(/\/$/, "") === cleanSel)
                        );
                        if (matched) {
                          return (
                            <span style={{ fontFamily: 'monospace', fontSize: '13px' }}>
                              {matched.isPrimary ? `Domain : ${matched.url}` : `Subdomain : ${matched.url}`}
                            </span>
                          );
                        }
                        return selected || "";
                      }}
                      sx={{
                        bgcolor: 'white',
                        '& .MuiOutlinedInput-root': { borderRadius: '8px' },
                        '& .MuiSelect-select': { py: 1.5, fontWeight: 600, color: '#32325D' }
                      }}
                    >
                      {this.state.availableBaseUrls.map((item) => (
                        <MenuItem key={item.id || item.url} value={item.isPrimary ? "" : item.url}>
                          <span style={{ fontFamily: 'monospace', fontSize: '13px' }}>
                            {item.isPrimary ? `Domain : ${item.url}` : `Subdomain : ${item.url}`}
                          </span>
                        </MenuItem>
                      ))}
                    </Select>
                    <Typography variant="caption" sx={{ color: '#8898AA', display: 'block', mt: 0.5, fontSize: '11px' }}>
                      Select a Base URL to publish this content to.
                    </Typography>
                  </Box>
                )}

                {/* Unsubscribe Text - Show for newsletter category */}
                {category?.toLowerCase() === 'newsletter' && (
                  <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, pr: 1, pl: 0 }}>
                      <Typography variant="caption" sx={{ display: 'block', color: '#8898AA', fontWeight: 700 }}>INCLUDE UNSUBSCRIBE LINK</Typography>
                      <Switch 
                        checked={this.state.includeUnsubscribeLink !== false} 
                        onChange={(e) => this.setState({ includeUnsubscribeLink: e.target.checked })}
                        size="small"
                        color="primary"
                        sx={{ ml: 1 }}
                      />
                    </Box>
                    {this.state.includeUnsubscribeLink !== false && (
                      <Box>
                        <Typography variant="caption" sx={{ mb: 1, mt: 1, display: 'block', color: '#8898AA', fontWeight: 700 }}>UNSUBSCRIBE TEXT</Typography>
                        <TextField
                          placeholder="Customize unsubscribe text..."
                          value={this.state.unsubscribeText}
                          onChange={(e) => this.setState({ unsubscribeText: e.target.value })}
                          multiline
                          rows={2}
                          fullWidth
                          variant="outlined"
                          size="small"
                          sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                        <Box sx={{ mt: 1, p: 1.5, bgcolor: '#F8FAFC', borderRadius: '8px', border: '1px solid #E2E8F0' }}>
                          <Typography variant="caption" sx={{ display: 'block', color: '#64748B', mb: 0.5, fontWeight: 600 }}>
                            Final footer will look like this:
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#334155' }}>
                            {this.state.unsubscribeText.trim()} <span style={{ color: '#0d3559', textDecoration: 'underline', fontWeight: 600 }}>unsubscribe here.</span>
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Box>
                )}

                {/* Event Date Fields - Show only for event category */}
                {category?.toLowerCase() === 'event' && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#8898AA', fontWeight: 700 }}>EVENT START DATE</Typography>
                    <TextField
                      type="date"
                      placeholder="Select start date"
                      value={this.state.eventStartDate}
                      onChange={(e) => this.setState({ eventStartDate: e.target.value })}
                      fullWidth
                      size="small"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        bgcolor: 'white',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                          bgcolor: 'white'
                        },
                        '& .MuiInputBase-input': {
                          py: 1.5,
                          fontWeight: 400,
                          color: '#32325D',
                          bgcolor: 'white',
                          '&::placeholder': {
                            color: '#ADB5BD',
                            opacity: 1,
                            fontWeight: 400
                          },
                          '&::-webkit-datetime-edit': {
                            color: this.state.eventStartDate ? '#32325D' : '#ADB5BD',
                            fontWeight: 400
                          },
                          '&::-webkit-calendar-picker-indicator': {
                            filter: 'opacity(0.5)'
                          }
                        }
                      }}
                    />

                    <Typography variant="caption" sx={{ mb: 1, mt: 2, display: 'block', color: '#8898AA', fontWeight: 700 }}>EVENT END DATE (Optional)</Typography>
                    <TextField
                      type="date"
                      placeholder="Select end date"
                      value={this.state.eventEndDate}
                      onChange={(e) => this.setState({ eventEndDate: e.target.value })}
                      fullWidth
                      size="small"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        bgcolor: 'white',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                          bgcolor: 'white'
                        },
                        '& .MuiInputBase-input': {
                          py: 1.5,
                          fontWeight: 400,
                          color: '#32325D',
                          bgcolor: 'white',
                          '&::placeholder': {
                            color: '#ADB5BD',
                            opacity: 1,
                            fontWeight: 400
                          },
                          '&::-webkit-datetime-edit': {
                            color: this.state.eventEndDate ? '#32325D' : '#ADB5BD',
                            fontWeight: 400
                          },
                          '&::-webkit-calendar-picker-indicator': {
                            filter: 'opacity(0.5)'
                          }
                        }
                      }}
                    />
                    <Typography variant="caption" sx={{ mt: 0.5, display: 'block', color: '#8898AA', fontStyle: 'italic' }}>
                      Leave end date empty for single-day events
                    </Typography>

                    <Typography variant="caption" sx={{ mb: 1, mt: 2, display: 'block', color: '#8898AA', fontWeight: 700 }}>EVENT LOCATION</Typography>
                    <TextField
                      placeholder="e.g. London, UK or Virtual Event"
                      value={this.state.eventLocation}
                      onChange={(e) => this.setState({ eventLocation: e.target.value })}
                      fullWidth
                      size="small"
                      variant="outlined"
                      sx={{
                        bgcolor: 'white',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                          bgcolor: 'white'
                        },
                        '& .MuiInputBase-input': {
                          py: 1.5,
                          fontWeight: 400,
                          color: '#32325D',
                          bgcolor: 'white'
                        }
                      }}
                    />
                  </Box>
                )}

                <Box sx={{ mb: 3 }}>
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#8898AA', fontWeight: 700 }}>TAGS</Typography>
                    {selectedTags.length > 0 && (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
                        {selectedTags.map((tag, i) => (
                          <Chip key={i} label={tag} size="small" onDelete={() => this.removeTag(i)}
                            sx={{ bgcolor: 'rgba(13,53,89,0.08)', color: '#0d3559', fontWeight: 600, '& .MuiChip-deleteIcon': { color: '#0d3559' } }}
                          />
                        ))}
                      </Box>
                    )}
                    <TextField select value="" onChange={this.handleTagChange} fullWidth size="small" variant="outlined"
                      sx={{ bgcolor: 'white', mb: 1, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                    >
                      <MenuItem value="" disabled>Add predefined tag...</MenuItem>
                      {allTags.filter(t => !selectedTags.includes(t)).map((tag, idx) => (
                        <MenuItem key={idx} value={tag}>{tag}</MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      placeholder="Or type a custom tag + Enter"
                      value={tagInput}
                      onChange={(e) => this.setState({ tagInput: e.target.value })}
                      onKeyDown={this.handleTagInputKeyDown}
                      fullWidth size="small" variant="outlined"
                      sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                    />
                  </Box>


                  {/* SEO Keywords - Admin fills */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#8898AA', fontWeight: 700 }}>
                      SEO KEYWORDS
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
                      {this.state.seo.metaKeywords.map((keyword, i) => (
                        <Chip
                          key={i}
                          label={keyword}
                          size="small"
                          onDelete={() => {
                            const newKeywords = [...this.state.seo.metaKeywords];
                            newKeywords.splice(i, 1);
                            this.setState({
                              seo: { ...this.state.seo, metaKeywords: newKeywords }
                            });
                          }}
                          sx={{ bgcolor: 'rgba(13,53,89,0.08)', color: '#0d3559', fontWeight: 600 }}
                        />
                      ))}
                    </Box>
                    <TextField
                      placeholder="Type keyword and press Enter"
                      value={this.state.seoKeywordInput}
                      onChange={(e) => this.setState({ seoKeywordInput: e.target.value })}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' && this.state.seoKeywordInput.trim()) {
                          e.preventDefault();
                          const keyword = this.state.seoKeywordInput.trim();
                                                                              if (!this.state.seo.metaKeywords.includes(keyword)) {
                            const newKeywords = [...this.state.seo.metaKeywords, keyword];
                                                        this.setState({
                              seo: {
                                ...this.state.seo,
                                metaKeywords: newKeywords
                              },
                              seoKeywordInput: ''
                            }, () => {
                                                          });
                          } else {
                                                        this.setState({ seoKeywordInput: '' });
                          }
                        }
                      }}
                      fullWidth
                      variant="outlined"
                      size="small"
                      sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                    />
                  </Box>
                  {/* SEO Short Description - Manual input */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#8898AA', fontWeight: 700 }}>
                      SEO SHORT DESCRIPTION
                    </Typography>
                    <TextField
                      placeholder="Enter SEO meta description (recommended 150-160 characters)"
                      value={this.state.seo.metaDescription}
                      onChange={(e) => this.setState({ 
                        seo: { ...this.state.seo, metaDescription: e.target.value }
                      })}
                      fullWidth
                      variant="outlined"
                      size="small"
                      multiline
                      rows={3}
                      sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                      helperText={`${this.state.seo.metaDescription.length} / 160 characters`}
                    />
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    {category?.toLowerCase() !== 'newsletter' && (
                      <>
                      </>
                    )}
                    {category !== 'newsletter' && (
                      <>
                        <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#8898AA', fontWeight: 700, mt: 2 }}>SORT ORDER</Typography>
                        <TextField
                          type="number"
                          placeholder="Enter sort order..."
                          value={sort}
                          onChange={(e) => this.setState({ sort: parseInt(e.target.value) || 0 })}
                          fullWidth
                          variant="outlined"
                          size="small"
                          sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                      </>
                    )}
                  </Box>

                {category !== 'newsletter' && (
                  <Box sx={{ mb: 3 }}>
                     <Typography variant="caption" sx={{ mb: 1, display: 'block', color: '#8898AA', fontWeight: 700 }}>THUMBNAIL IMAGE</Typography>
                     <Box sx={{ display: 'flex', gap: 1, mb: thumbnail ? 1.5 : 0 }}>
                       <TextField
                         placeholder="Paste image URL..."
                         value={thumbnail}
                         onChange={this.handleThumbnailUrlChange}
                         fullWidth
                         size="small"
                         variant="outlined"
                         sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                       />
                       <Button
                         variant="outlined"
                         component="label"
                         size="small"
                         disabled={isUploading}
                         startIcon={isUploading ? <CircularProgress size={16} /> : <CloudUploadIcon />}
                         sx={{ whiteSpace: 'nowrap', minWidth: 'auto', px: 1.5, borderRadius: '8px', borderColor: '#E9ECEF' }}
                       >
                         {isUploading ? '' : 'Upload'}
                         <input type="file" hidden accept="image/*" onChange={this.handleFileUpload} />
                       </Button>
                     </Box>
                      {thumbnail && (
                        <Box sx={{ mt: 1, borderRadius: '8px', overflow: 'hidden', border: '1px solid #E9ECEF', position: 'relative' }}>
                          <Box sx={{ height: 120, width: '100%', overflow: 'hidden' }}>
                              <img src={resolveImageUrl(thumbnail)} alt="Thumbnail preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          </Box>
                          <Box sx={{ p: 1, bgcolor: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #E9ECEF' }}>
                              <Typography variant="caption" sx={{ color: '#8898AA', maxWidth: '60%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                  {thumbnail}
                              </Typography>
                              <Box sx={{ display: 'flex', gap: 0.5 }}>
                                  <Button
                                      size="small"
                                      onClick={() => {
                                          navigator.clipboard.writeText(thumbnail);
                                          this.props.messageShow("URL copied to clipboard!");
                                      }}
                                      sx={{ fontSize: '10px', py: 0, minWidth: 'auto', textTransform: 'none' }}
                                  >
                                      Copy
                                  </Button>
                                  <Button
                                      size="small"
                                      component="a"
                                      href={thumbnail}
                                      target="_blank"
                                      sx={{ fontSize: '10px', py: 0, minWidth: 'auto', textTransform: 'none' }}
                                  >
                                      View
                                  </Button>
                              </Box>
                          </Box>
                          <IconButton
                            size="small"
                            onClick={() => this.setState({ thumbnail: '' })}
                            sx={{ position: 'absolute', top: 4, right: 4, bgcolor: 'rgba(13, 53, 89, 0.7)', color: 'white', '&:hover': { bgcolor: '#0d3559' }, padding: '2px' }}
                          >
                            <span style={{ fontSize: 12, lineHeight: 1, fontWeight: 700, padding: '2px 4px' }}>✕</span>
                          </IconButton>
                        </Box>
                      )}
                   </Box>
                )}

                <Box sx={{ mt: 5, display: 'flex', flexDirection: 'column', gap: 2 }}>
                   <Button
                    variant="contained"
                    fullWidth
                    onClick={this.handleSave}
                    disabled={!canSave}
                    sx={{
                      py: 1.5,
                      fontWeight: 700,
                      borderRadius: '12px',
                      textTransform: 'none',
                      background: 'linear-gradient(135deg, #0d3559 0%, #1a4f7c 100%)',
                      color: 'white',
                      boxShadow: '0 4px 15px rgba(13, 53, 89, 0.25)',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #0a2b48 0%, #154269 100%)',
                        boxShadow: '0 6px 20px rgba(13, 53, 89, 0.35)',
                        transform: 'translateY(-2px)'
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    {status === 'published' ? (category === 'newsletter' ? 'Publish Newsletter' : 'Publish Content') : (cmsId ? "Update Template" : "Save Template")}
                  </Button>

                  <Button
                    variant="outlined"
                    color="inherit"
                    fullWidth
                    onClick={this.handleClear}
                     disabled={!canSave}
                    sx={{ py: 1.5, fontWeight: 600, borderRadius: '8px', textTransform: 'none', border: '1px solid #E9ECEF' }}
                  >
                    Clear All
                  </Button>
                </Box>
              </Box>

                {isModal && (
                  <Box sx={{ mt: 3, p: 2, bgcolor: 'rgba(13, 53, 89, 0.05)', borderRadius: '8px', border: '1px dashed #0d3559' }}>
                    <Typography variant="caption" sx={{ color: '#0d3559', fontWeight: 600 }}>
                      💡 Pro Tip:
                    </Typography>
                    <Typography variant="caption" display="block" sx={{ color: '#525F7F', mt: 0.5 }}>
                      Grouping templates with consistent tags helps in filtering and organizing your site's dynamic content.
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Preview Modal */}
        <Modal
          open={isPreviewOpen}
          onClose={() => this.setState({ isPreviewOpen: false })}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Box sx={{ width: '90%', maxWidth: 900, maxHeight: '90vh', overflowY: 'auto', bgcolor: 'background.paper', borderRadius: '8px', p: 0, outline: 'none' }}>
            <Box>
              <Box sx={{ p: 3, borderBottom: '1px solid #F1F3F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, bgcolor: 'white', zIndex: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: '#32325D', fontSize: '1.1rem' }}>Content Preview</Typography>
                <IconButton onClick={() => this.setState({ isPreviewOpen: false })}>
                  <CloseIcon />
                </IconButton>
              </Box>

              <Box sx={{ p: 4 }}>
                {thumbnail && (
                  <Box sx={{ width: '100%', height: 350, mb: 4, borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
                    <img src={resolveImageUrl(thumbnail)} alt="Hero" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </Box>
                )}

                <Box sx={{ mb: 4 }}>
                  <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
                    {selectedTags.map((t, i) => (
                      <Chip key={i} label={t.toUpperCase()} size="small"
                        sx={{ fontWeight: 700, fontSize: '0.65rem', color: '#0d3559', bgcolor: 'rgba(13, 53, 89, 0.1)', border: 'none' }}
                      />
                    ))}
                    {/* Removed order chip from preview */}
                  </Box>

                  <Typography variant="h5" sx={{ fontWeight: 700, color: '#000000', lineHeight: 1.3, mb: 1 }}>
                    {title || "Untitled Content"}
                  </Typography>
                  {subtitle && (
                    <Typography variant="subtitle2" sx={{ color: '#525F7F', mb: 2, fontStyle: 'italic', fontWeight: 500 }}>
                      {subtitle}
                    </Typography>
                  )}

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, pb: 3, borderBottom: '1px solid #F1F3F9', color: '#8898AA' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                          <UserIcon sx={{ fontSize: 16, color: '#525F7F' }} />
                          <Typography variant="caption" fontWeight={700} sx={{ color: authorName ? '#525F7F' : (status === 'published' ? '#2e7d32' : '#ed6c02'), fontSize: '0.85rem' }}>
                              {authorName ? `By ${authorName}` : (status === 'published' ? 'Published Version' : 'Draft Preview')}
                          </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <CalendarIcon sx={{ fontSize: 14 }} />
                          <Typography variant="caption">{new Date().toLocaleDateString()}</Typography>
                      </Box>
                  </Box>
                </Box>

                <Box
                  className="ql-editor ck-content"
                  onClick={(e) => {
                    const link = e.target.closest('a');
                    if (link && link.href) {
                      e.preventDefault();
                      window.open(link.href, '_blank', 'noopener,noreferrer');
                    }
                  }}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(content, {
                      ADD_TAGS: ["iframe", "figure", "oembed", "video", "source", "script"],
                      ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "src", "data-oembed-url", "url", "width", "height", "style", "title", "loading", "autoplay", "muted", "controls", "playsinline", "srcdoc", "itemprop", "itemtype", "content", "target", "rel"]
                    })
                  }}
                  sx={{
                    fontSize: '0.9rem', lineHeight: 1.6, color: '#000000', overflowWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'normal',
                    '& h1, & h2, & h3, & h4, & h5, & h6': { color: '#000000', mt: 2, mb: 1, fontWeight: 700, fontSize: '1.25rem !important' },
                    '& p': { mb: 1.5 },
                    '& iframe': {
                      width: '100% !important',
                      aspectRatio: '16 / 9',
                      minHeight: { xs: 200, sm: 300, md: 450 },
                      borderRadius: '12px',
                      border: 'none',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                      my: 3,
                      display: 'block',
                      background: '#000'
                    },
                    '& figure.media, & figure, & oembed': {
                      width: '100% !important',
                      margin: '24px 0 !important',
                      display: 'block'
                    }
                  }}
                />

                {/* Newsletter Unsubscribe Link Preview */}
                {category?.toLowerCase() === 'newsletter' && this.state.includeUnsubscribeLink !== false && (
                  <Box sx={{ mt: 5, pt: 3, borderTop: '1px dashed #E5E7EB', textAlign: 'center' }}>
                    <Typography 
                      variant="caption" 
                      sx={{ color: '#6B7280', fontSize: '0.8rem' }}
                      dangerouslySetInnerHTML={{ 
                        __html: (() => {
                          const text = (this.state.unsubscribeText || "If you no longer wish to receive these emails, you can").trim() + " unsubscribe here.";
                          if (text.toLowerCase().includes("unsubscribe here")) {
                            return text.replace(/unsubscribe here/i, '<span style="color: #0d3559; text-decoration: underline; font-weight: 600; cursor: pointer;">unsubscribe here</span>');
                          }
                          return `${text} <span style="color: #0d3559; text-decoration: underline; font-weight: 600; cursor: pointer;">unsubscribe here</span>`;
                        })()
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Modal>

        {/* Newsletter Publish Confirmation Modal */}
        <Modal 
          open={Boolean(this.state.isNewsletterPublishModalOpen)} 
          onClose={() => this.setState({ isNewsletterPublishModalOpen: false })} 
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Box sx={{ width: 480, maxWidth: '92vw', bgcolor: 'background.paper', borderRadius: '16px', p: 3.5, outline: 'none', boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
              <Typography variant="h6" sx={{ fontWeight: 800, color: '#32325D', fontSize: '1.1rem' }}>
                Publish Newsletter
              </Typography>
              <IconButton size="small" onClick={() => this.setState({ isNewsletterPublishModalOpen: false })} sx={{ color: '#8898AA' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            <Typography variant="body2" sx={{ color: '#525F7F', mb: 1, fontSize: '0.875rem' }}>
              Choose how you would like to publish this newsletter:
            </Typography>
            
            <Typography variant="body2" sx={{ color: '#32325D', fontWeight: 600, mb: 3, fontSize: '0.875rem', bgcolor: '#F8F9FE', p: 1.5, borderRadius: '8px', border: '1px solid #E9ECEF' }}>
              "{this.state.title}"
            </Typography>

            <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1.5} sx={{ mt: 2 }}>
              <Button
                onClick={() => this.setState({ isNewsletterPublishModalOpen: false })}
                sx={{ color: '#525F7F', fontWeight: 600, textTransform: 'none', fontSize: '0.85rem' }}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => this.saveContent(false)}
                sx={{
                  py: 0.8,
                  px: 2,
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '0.85rem',
                  borderColor: '#E2E8F0',
                  color: '#525F7F',
                  '&:hover': { borderColor: '#0d3559', color: '#0d3559', bgcolor: 'rgba(13, 53, 89, 0.04)' }
                }}
              >
                Publish Only
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={() => this.saveContent(true)}
                startIcon={<NewsletterIcon sx={{ fontSize: '1rem !important' }} />}
                sx={{
                  py: 0.8,
                  px: 2.2,
                  bgcolor: '#0d3559',
                  borderRadius: '8px',
                  fontWeight: 700,
                  textTransform: 'none',
                  fontSize: '0.85rem',
                  '&:hover': { bgcolor: '#0a2a47' }
                }}
              >
                Publish & Send
              </Button>
            </Box>
          </Box>
        </Modal>
      </Box>
    );
  }
}

CreateOrUpdate.propTypes = {
  messageShow: PropTypes.func.isRequired,
  createOrUpdateCms: PropTypes.func.isRequired,
  getCmsById: PropTypes.func.isRequired,
  uploadThumbnail: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  createOrUpdateCategory: PropTypes.func.isRequired,
  createEvent: PropTypes.func.isRequired,
  getBaseUrls: PropTypes.func,
};

export default connect(null, {
  messageShow,
  getCms,
  getCmsById,
  createOrUpdateCms,
  uploadThumbnail,
  createEvent,
  getCategories,
  createOrUpdateCategory,
  getBaseUrls
})(withRouter(withStyles(styles)(CreateOrUpdate)));